import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Layout from "layouts/layout";
import Table from "components/table/table";
import ListContainer from "components/list/list-container";
import ListHeader from "components/list/list-header";
import _ from "lodash";
import { Profile1 } from "constants/images";
import ActionIconBtn from "components/button/action-btn";
import EditPencilIconSVG from "assets/svg/edit-pencil-icon";
import moment from "moment";
import CategoryDeleteModal from "components/categories/category-delete-modal";
import CategoryHasMilestoneModal from "components/categories/category-has-milestone-modal";
import { useDialogHook } from "utils/customhooks";
import CategoryAddModal from "components/categories/category-add-modal";
import { urlSerializer } from "utils/utils";
import ToolTip from "components/tooltip/tooltip";
import { HiMiniLanguage } from "react-icons/hi2";
import Modal from "components/global/modal";
import toast from "react-hot-toast";

import {
  REFRESH_CATEGORIES,
  GET_CATEGORIES,
  SET_CATEGORIES,
} from "redux/modules/category-management/types";

export default function Categories() {
  const { http } = global.services;
  const {
    limit,
    page,
    categories = [],
    initialize,
    refresh,
    loadMore,
    isRequesting,
    pages = [],
  } = useSelector((state) => state.category);
  const query = useQuery();
  const searchValue = query.get("search");
  const [filterValue, setFilterValue] = useState(searchValue);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showTranslate,setShowTranslate] = useState(false);
  const modal = useDialogHook(CategoryAddModal);
  const _delete = useDialogHook(CategoryDeleteModal);
  const _hasMilestone = useDialogHook(CategoryHasMilestoneModal);
  const dispatch = useDispatch();

  const getCategories = async (selectedPage = null) => {
    if (isRequesting || !loadMore) return;

    dispatch({ type: GET_CATEGORIES, payload: [] });

    try {
      const url = urlSerializer("categories/list", {
        search: filterValue,
        page: selectedPage ?? page,
        limit: limit,
      });
      const { data } = await http.get(url);
      const _loadMore = data.data.length > 0 ? true : false;
      // const _page = data.data.length > 0 ? page + 1 : page;
      const _page = data.current_page;
      const _lastPage = data.last_page;

      dispatch({
        type: SET_CATEGORIES,
        payload: {
          data: data.data,
          loadMore: _loadMore,
          page: _page,
          lastPage: _lastPage,
        },
      });
    } catch (err) {
      console.log("error@getCategories", err);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();

    dispatch({
      type: REFRESH_CATEGORIES,
      payload: [],
    });
  };

  const handleAddEdit = (data = {}) => {
    modal(data, (result) => {
      if (!_.isEmpty(result)) {
        if (result === "add") {
          dispatch({
            type: REFRESH_CATEGORIES,
            payload: [],
          });
        } else if (result === "delete") {
          handleDelete(data);
        }
      }
    });
  };

  const handleDelete = async (data = {}) => {
    const url = urlSerializer(`categories/check/${data.id}`);
    const result = await http.get(url);
    const has_milestones = result.data.has_milestones;
    if (has_milestones) {
      _hasMilestone(result.data, (result) => {

      });
    }
    else {
      _delete(data, (result) => {
        if (!_.isEmpty(result)) {
          console.log("result ", result);
          if (result === "delete") {
            dispatch({
              type: REFRESH_CATEGORIES,
              payload: [],
            });
          }
        }
      }); 
    }
  };

  const translateName = async(data = {})=>{
    try{
      setShowTranslate(true);
      const url = urlSerializer(`categories/translate/${data.id}`);
      const result = await http.put(url);
      if(result?.data?.success){
        toast.success('Successfully updated');
        dispatch({
          type: REFRESH_CATEGORIES,
          payload: [],
        });
      }
    }catch(e){
      console.error(e);
      toast.error('Something went wrong');
    }finally{
      setShowTranslate(false)
    }
  }

  const TranslateLoading = ()=>{
    return (

      <Modal
        width="w-19/20 md:w-16/20 2md:w-12/20 3md:w-8/20 1xl:w-6/20"
        contentClassName="rounded-lg overflow-auto custom-scroll"
        wrapperClassName="overflow-visible"
        footerClass="border-t border-mutedGray"
      >
        <div className="w-full">
          {/* content */}
          <div className="pl-10 pr-7 py-7">
            <p className="text-lightBlack font-bold text-center">
              Translate ...
            </p>
          </div>
        </div>
      </Modal>
    )
  }

  const columns = [
    {
      title: "Category Title",
      dataIndex: "name",
      nowrap: true,
      key: "name",
      render: (record) => (
        <div className="w-full flex items-center">
          {record.name ? (
            <>
              {/* <img
                src={Profile1}
                alt="account"
                className="account-img mr-2.5"
              /> */}
              <p>{record.name}</p>
            </>
          ) : (
            <p>--</p>
          )}
        </div>
      ),
    },
    {
      title: "English",
      dataIndex: "en",
      nowrap: true,
      key: "en",
      render: (record) => (
        <div className="w-full flex items-center">
          {record.en ? (
            <>
              <p>{record.en}</p>
            </>
          ) : (
            <p>--</p>
          )}
        </div>
      ),
    },{
      title: "Arabic",
      dataIndex: "ar",
      nowrap: true,
      key: "ar",
      render: (record) => (
        <div className="w-full flex items-center">
          {record.ar ? (
            <>
              <p>{record.ar}</p>
            </>
          ) : (
            <p>--</p>
          )}
        </div>
      ),
    },
    {
      title: "Bengali",
      dataIndex: "bn",
      nowrap: true,
      key: "bn",
      render: (record) => (
        <div className="w-full flex items-center">
          {record.bn ? (
            <>
              <p>{record.bn}</p>
            </>
          ) : (
            <p>--</p>
          )}
        </div>
      ),
    },
    {
      title: "Chinese",
      dataIndex: "ch",
      nowrap: true,
      key: "ch",
      render: (record) => (
        <div className="w-full flex items-center">
          {record.ch ? (
            <>
              <p>{record.ch}</p>
            </>
          ) : (
            <p>--</p>
          )}
        </div>
      ),
    },
    {
      title: "Frence",
      dataIndex: "fr",
      nowrap: true,
      key: "fr",
      render: (record) => (
        <div className="w-full flex items-center">
          {record.fr ? (
            <>
              <p>{record.fr}</p>
            </>
          ) : (
            <p>--</p>
          )}
        </div>
      ),
    },
    {
      title: "Hindi",
      dataIndex: "hi",
      nowrap: true,
      key: "hi",
      render: (record) => (
        <div className="w-full flex items-center">
          {record.hi ? (
            <>
              <p>{record.hi}</p>
            </>
          ) : (
            <p>--</p>
          )}
        </div>
      ),
    },
    {
      title: "Spanish",
      dataIndex: "es",
      nowrap: true,
      key: "es",
      render: (record) => (
        <div className="w-full flex items-center">
          {record.es ? (
            <>
              <p>{record.es}</p>
            </>
          ) : (
            <p>--</p>
          )}
        </div>
      ),
    },
    {
      title: "Portugues",
      dataIndex: "pt",
      nowrap: true,
      key: "pt",
      render: (record) => (
        <div className="w-full flex items-center">
          {record.pt ? (
            <>
              <p>{record.pt}</p>
            </>
          ) : (
            <p>--</p>
          )}
        </div>
      ),
    },
    {
      title: "Russian",
      dataIndex: "ru",
      nowrap: true,
      key: "ru",
      render: (record) => (
        <div className="w-full flex items-center">
          {record.ru ? (
            <>
              <p>{record.ru}</p>
            </>
          ) : (
            <p>--</p>
          )}
        </div>
      ),
    },
    {
      title: "Urdu",
      dataIndex: "ur",
      nowrap: true,
      key: "ur",
      render: (record) => (
        <div className="w-full flex items-center">
          {record.ur ? (
            <>
              <p>{record.ur}</p>
            </>
          ) : (
            <p>--</p>
          )}
        </div>
      ),
    },

    // {
    //   title: "Description",
    //   dataIndex: "description",
    //   nowrap: true,
    //   key: "description",
    //   render: (record) => (
    //     <p>
    //       {_.truncate(record?.description, {
    //         length: 71,
    //       })}
    //     </p>
    //   ),
    // },
    // {
    //   title: "Group Category",
    //   dataIndex: "group",
    //   nowrap: true,
    //   key: "group",
    // },
    // {
    //   title: "Date Created",
    //   dataIndex: "created_at",
    //   nowrap: true,
    //   key: "dateCreated",
    //   render: (record) => (
    //     <p>{moment(record.created_at).format("MMMM DD, YYYY")}</p>
    //   ),
    // },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      hideSorting: true,
      nowrap: true,
      render: (record) => (
        <div className="flex space-x-4">
          <ToolTip
            value={`Translate`}
            backgroundColor="#0c6ed1"
            color="white"
            width='97px'
            >
            <ActionIconBtn
              className="action-btn-round"
              icon={<HiMiniLanguage  className="m-auto" />}
              onClick={() => translateName(record)}
            />
          </ToolTip>
          <ToolTip
            value={`Edit Category`}
            backgroundColor="#0c6ed1"
            color="white"
            width='97px'
            >
            <ActionIconBtn
              className="action-btn-round"
              icon={<EditPencilIconSVG className="m-auto" />}
              onClick={() => handleAddEdit(record)}
            />
          </ToolTip>
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (initialize) getCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, initialize]);

  return (
    <Layout title="Categories" routeName="categories">
      {
        showTranslate &&
        <TranslateLoading/>
      }
      <div className="main-page-wrapper">
        <ListContainer
          header={
            <ListHeader
              title="List"
              countValue={_.size(categories)}
              filterValue={filterValue}
              setFilterValue={setFilterValue}
              buttonName="+ Add Category"
              showAddButton={true}
              onClickButton={() => handleAddEdit()}
              onSearch={(e) => handleSearch(e)}
              filter ={false}
            />
          }
        >
          <Table
            columns={columns}
            dataSource={categories}
            pagination={true}
            selectable={true}
            selected={selectedRows}
            onSelected={(selectedRows) => {
              setSelectedRows(selectedRows);
            }}
            perPage={10}
            currentPage={page}
            onHandleChangePage={getCategories}
            pages={pages}
          />
        </ListContainer>
      </div>
    </Layout>
  );
}

const useQuery = () => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
};
